const RELOADED_AT_KEY = 'preloadErrorReloadedAt'
const RELOAD_COOLDOWN_MS = 60_000

let reloadPending = false

// After a deploy, chunks referenced by an already-open tab no longer exist on
// Firebase Hosting, so dynamic imports fail. Reloading fetches a fresh
// index.html that points at existing chunks. The cooldown prevents a reload
// loop when the failure is not deploy-related (e.g. a network issue): repeated
// failures propagate to Bugsnag instead. Returns whether a reload is underway,
// so callers can suppress the chunk error.
export const reloadOnChunkError = () => {
  if (reloadPending) return true

  const reloadedAt = Number(sessionStorage.getItem(RELOADED_AT_KEY))

  if (Date.now() - reloadedAt < RELOAD_COOLDOWN_MS) return false

  reloadPending = true
  sessionStorage.setItem(RELOADED_AT_KEY, String(Date.now()))
  window.location.reload()

  return true
}
